import card from './card.json';
import common from './common.json';
import credit from './credit.json';
import input from './input.json';

const translation = (
  {
    ...card,
    ...common,
    ...credit,
    ...input,
  }
)

export default translation;